// Copyright (c) 2016 Deere & Company

import Modal, { getDefaultState as getModalDefaultState } from '../../../../sharedmodules/state/modal';

const NewTransferStatusChangeModal = Modal;

export const getDefaultState = () => getModalDefaultState();

export default NewTransferStatusChangeModal;
